export default "__VITE_ASSET__1UMm$cq7__"